angular.module('unica_event_field.event_field_services')

.factory('EventFieldDeleteService', function ($http, getBaseApiURL) {

	var eventFieldDeleteService = {};

	eventFieldDeleteService.delete = function (eventFieldId) {
		return $http({
			method: 'DELETE',
			url: getBaseApiURL + '/event-field/delete/' + eventFieldId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});
	};



	return eventFieldDeleteService;
});